<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-vehicle"
      entity-name="车辆"
      add-btn="新增车辆"
      hide-show-detail
      :hide-action="!editable"
      :modal-width="640"
      :modal-form="modalForm"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :search-key-type="{car_number: 1}"
      v-if="activity">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.car_number" placeholder="输入车牌号查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="车牌号" prop="car_number">
          <a-input v-model="form.car_number" placeholder="请输入车辆车牌号"></a-input>
        </a-form-model-item>
        <a-form-model-item label="车辆类型" prop="car_type">
          <a-select
            placeholder="请选择车辆类型"
            @change="updateList"
            :options="vehicleTypeList"
            v-model="form.car_type">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="车辆品牌" prop="brand">
          <a-input v-model="form.brand" placeholder="请输入车辆品牌"></a-input>
        </a-form-model-item>
        <a-form-model-item label="座位数" prop="seats">
          <a-input-number v-model="form.seats" :min="1" placeholder="请输入车辆座位数" style="width:100%"></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="司机">
          <select-entity
            v-model="form.driver"
            btn-text="选择司机"
            url="/activity/activity-driver"
            :query="`&filter[activity_id]=${activity.id}`"
            :columns="driverColumns">
          </select-entity>
        </a-form-model-item>
        <a-form-model-item label="通行证">
          <select-entity
            v-model="form.passCheck"
            btn-text="选择通行证"
            url="/activity/activity-pass-check"
            name-key="type"
            :query="`&filter[activity_id]=${activity.id}`"
            :columns="passColumns">
          </select-entity>
        </a-form-model-item>
      </template>
    </data-list>
  </div>
</template>

<script>
    import {vehicleTypeList, driverColumns, passColumns, vehicleColumns} from "../../../common/activity/vehicle";
    import mixins from "../mixins";

    export default {
        name: "ActivityVehicle",
        data() {
            return {
                columns: vehicleColumns,
                rules: {
                    car_number: [{ required: true, message: '请输入车辆车牌号', trigger: 'blur' }],
                    car_type: [{ required: true, message: '请选择车辆类型', trigger: 'change' }],
                    brand: [{ required: true, message: '请输入车辆品牌', trigger: 'blur' }],
                    seats: [{ required: true, message: '请输入车辆座位数', trigger: 'blur' }],
                },
                driverColumns,
                passColumns,
                vehicleTypeList,
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 4},
                    wrapperCol: {span: 20}
                },
                moduleKey: 'traffic-vehicle',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=driver,passCheck';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                if(form.driver) {
                    form.driver_id = form.driver.id;
                }
                if(form.passCheck) {
                    form.pass_id = form.passCheck.id;
                }
                fn();
            },
            importStaff() {
                this.visible = true;
            },
            confirmModal() {

            },
            handleFileSelect(e) {
                let file = e.target.files[0];
                this.file = file;
            },
            // 拖拽上传
            fileDragover (e) {
                e.preventDefault()
            },
            fileDrop (e) {
                e.preventDefault();
                const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象
                this.file = file;
            },
            updateList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
